export interface NewsItem {
    image: string
    title: string
    text: string
    date: string
    href: string
    tags: string[]
}

export const indexNews: NewsItem[] = [
    {
        image: '/images/index-page/last-news/placeholder.png',
        title: 'Маркетплейсы 2024: Новые правила игры и ключевые изменения',
        text: 'Мир e-commerce в ноябре 2024 года столкнулся с рядом изменений, которые касаются всех участников рынка — от новичков до крупных брендов. Вот главные новости и тенденции, которые влияют на работу маркетплейсов прямо сейчас.',
        date: '21.11.2024',
        href: '#',
        tags: ['Бизнесу']
    },
]
